import { createSlice } from "@reduxjs/toolkit";

const dashboardStatsSlice = createSlice({
  name: "dashboardStats",
  initialState: {
    isLoading: false,
    // Module 1: Orders
    orderOverview: null,
    revenueByTime: [],
    orderStatusDistribution: [],
    topProducts: [],
    ordersByPaymentMethod: [],
    ordersBySource: [],
    // Module 2: Users
    userGrowth: [],
    userStatusDistribution: null,
    userAuthMethods: [],
    topUsersByFollowers: [],
    userEngagement: null,
    // Module 3: Social
    postTrends: [],
    reactionsSummary: null,
    topPosts: [],
    contentTypeBreakdown: [],
    chatStats: null,
    // Post detail
    postDetail: null,
    postDetailLoading: false,
  },
  reducers: {
    // ========== ORDER STATS ==========
    getOrderOverviewRequest(state) {
      return { ...state, isLoading: true };
    },
    getOrderOverviewSuccess(state, action) {
      return { ...state, isLoading: false, orderOverview: action.payload };
    },
    getRevenueByTimeRequest(state) {
      return { ...state, isLoading: true };
    },
    getRevenueByTimeSuccess(state, action) {
      return { ...state, isLoading: false, revenueByTime: action.payload };
    },
    getOrderStatusDistributionRequest(state) {
      return { ...state, isLoading: true };
    },
    getOrderStatusDistributionSuccess(state, action) {
      return { ...state, isLoading: false, orderStatusDistribution: action.payload };
    },
    getTopProductsRequest(state) {
      return { ...state, isLoading: true };
    },
    getTopProductsSuccess(state, action) {
      return { ...state, isLoading: false, topProducts: action.payload };
    },
    getOrdersByPaymentMethodRequest(state) {
      return { ...state, isLoading: true };
    },
    getOrdersByPaymentMethodSuccess(state, action) {
      return { ...state, isLoading: false, ordersByPaymentMethod: action.payload };
    },
    getOrdersBySourceRequest(state) {
      return { ...state, isLoading: true };
    },
    getOrdersBySourceSuccess(state, action) {
      return { ...state, isLoading: false, ordersBySource: action.payload };
    },

    // ========== USER STATS ==========
    getUserGrowthRequest(state) {
      return { ...state, isLoading: true };
    },
    getUserGrowthSuccess(state, action) {
      return { ...state, isLoading: false, userGrowth: action.payload };
    },
    getUserStatusDistributionRequest(state) {
      return { ...state, isLoading: true };
    },
    getUserStatusDistributionSuccess(state, action) {
      return { ...state, isLoading: false, userStatusDistribution: action.payload };
    },
    getUserAuthMethodsRequest(state) {
      return { ...state, isLoading: true };
    },
    getUserAuthMethodsSuccess(state, action) {
      return { ...state, isLoading: false, userAuthMethods: action.payload };
    },
    getTopUsersByFollowersRequest(state) {
      return { ...state, isLoading: true };
    },
    getTopUsersByFollowersSuccess(state, action) {
      return { ...state, isLoading: false, topUsersByFollowers: action.payload };
    },
    getUserEngagementRequest(state) {
      return { ...state, isLoading: true };
    },
    getUserEngagementSuccess(state, action) {
      return { ...state, isLoading: false, userEngagement: action.payload };
    },

    // ========== SOCIAL STATS ==========
    getPostTrendsRequest(state) {
      return { ...state, isLoading: true };
    },
    getPostTrendsSuccess(state, action) {
      return { ...state, isLoading: false, postTrends: action.payload };
    },
    getReactionsSummaryRequest(state) {
      return { ...state, isLoading: true };
    },
    getReactionsSummarySuccess(state, action) {
      return { ...state, isLoading: false, reactionsSummary: action.payload };
    },
    getTopPostsRequest(state) {
      return { ...state, isLoading: true };
    },
    getTopPostsSuccess(state, action) {
      return { ...state, isLoading: false, topPosts: action.payload };
    },
    getContentTypeBreakdownRequest(state) {
      return { ...state, isLoading: true };
    },
    getContentTypeBreakdownSuccess(state, action) {
      return { ...state, isLoading: false, contentTypeBreakdown: action.payload };
    },
    getChatStatsRequest(state) {
      return { ...state, isLoading: true };
    },
    getChatStatsSuccess(state, action) {
      return { ...state, isLoading: false, chatStats: action.payload };
    },

    // Post detail
    getPostDetailRequest(state) {
      return { ...state, postDetailLoading: true, postDetail: null };
    },
    getPostDetailSuccess(state, action) {
      return { ...state, postDetailLoading: false, postDetail: action.payload };
    },

    stopLoading(state) {
      return { ...state, isLoading: false, postDetailLoading: false };
    },
  },
});

export const {
  getOrderOverviewRequest,
  getOrderOverviewSuccess,
  getRevenueByTimeRequest,
  getRevenueByTimeSuccess,
  getOrderStatusDistributionRequest,
  getOrderStatusDistributionSuccess,
  getTopProductsRequest,
  getTopProductsSuccess,
  getOrdersByPaymentMethodRequest,
  getOrdersByPaymentMethodSuccess,
  getOrdersBySourceRequest,
  getOrdersBySourceSuccess,
  getUserGrowthRequest,
  getUserGrowthSuccess,
  getUserStatusDistributionRequest,
  getUserStatusDistributionSuccess,
  getUserAuthMethodsRequest,
  getUserAuthMethodsSuccess,
  getTopUsersByFollowersRequest,
  getTopUsersByFollowersSuccess,
  getUserEngagementRequest,
  getUserEngagementSuccess,
  getPostTrendsRequest,
  getPostTrendsSuccess,
  getReactionsSummaryRequest,
  getReactionsSummarySuccess,
  getTopPostsRequest,
  getTopPostsSuccess,
  getContentTypeBreakdownRequest,
  getContentTypeBreakdownSuccess,
  getChatStatsRequest,
  getChatStatsSuccess,
  getPostDetailRequest,
  getPostDetailSuccess,
  stopLoading,
} = dashboardStatsSlice.actions;

export default dashboardStatsSlice.reducer;
